import { ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import FloatingPromoWidget from '../ui/FloatingPromoWidget';
import PromotionalAdmin from '../ui/PromotionalAdmin';


interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Trigger loading state on route change
    setIsLoading(true);
    
    // Simulate loading time for smooth transition
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 150);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col overflow-x-hidden">
      <Header />
      
      {/* Page transition wrapper */}
      <main className="flex-1 relative">
        {isLoading && (
          <div className="fixed inset-0 z-50 bg-white/80 backdrop-blur-sm flex items-center justify-center">
            <div className="spinner-lg"></div>
          </div>
        )}
        
        <div 
          className={`${isLoading ? 'opacity-0' : 'opacity-100'} transition-opacity duration-300 ease-out`}
          key={location.pathname}
        >
          <div className="animate-page-fade-in">
            {children}
          </div>
        </div>
      </main>
      
      <Footer />
      
      {/* Floating Promotional Widget */}
      <FloatingPromoWidget />
      
      {/* Promotional Admin Panel */}
      <PromotionalAdmin />
    </div>
  );
};

export default Layout;